import React from 'react';
import { usePricing } from '../../hooks/usePricing';
interface PriceDisplayProps {
  type: 'offer' | 'regular' | 'total' | 'b1' | 'b2' | 'b3' | 'system' | 'protocol' | 'guide' | 'plans';
  className?: string;
  showCurrencyCode?: boolean;
}
export function PriceDisplay({
  type,
  className = '',
  showCurrencyCode = false
}: PriceDisplayProps) {
  const {
    pricing,
    isLoaded
  } = usePricing();
  if (!isLoaded) {
    return <span className={`animate-pulse bg-gray-200 rounded h-6 w-16 inline-block ${className}`} data-id="element-318"></span>;
  }
  let value = '';
  if (type === 'offer' || type === 'regular' || type === 'total') {
    value = pricing[type];
  } else if (type.startsWith('b')) {
    value = pricing.bonuses[type as keyof typeof pricing.bonuses];
  } else {
    value = pricing.values[type as keyof typeof pricing.values];
  }
  return <span className={className} data-id="element-319">
      {pricing.symbol}
      {value}{' '}
      {showCurrencyCode && <span className="text-sm opacity-80" data-id="element-320">{pricing.currency}</span>}
    </span>;
}